import {useEffect} from 'react';

import useSetUI from './useSetUI';
import useHistory from './useHistory';

const usePreviousUrl = () => {
	const history = useHistory();
	const setUi = useSetUI();

	useEffect(() => {
		let currentUrl = typeof window !== 'undefined' ? window.location.href : '';

		history.listen(() => {
			setUi.setPreviousUrl(currentUrl);
			currentUrl = window.location.href;
		});
	}, []);
};

export default usePreviousUrl;
